import { createContext } from "react";

export const NoteChartErrorContext = createContext(null);
